import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { LayoutGrid, Bookmark, Repeat2, FileText, ThumbsUp } from "lucide-react";

export default function AccountTab({ activeTab }) {
    const navigate = useNavigate();
    const tabs = [
        { name: "Posts", icon: LayoutGrid, path: "/account" },
        { name: "Saved", icon: Bookmark, path: "/account/saved" },
        { name: "Reposts", icon: Repeat2, path: "/account/repost" },
        { name: "Drafts", icon: FileText, path: "/account/drafts" },
        { name: "Liked", icon: ThumbsUp, path: "/account/liked" },
    ];

    return (
        <div className="sticky top-0 flex bg-white dark:bg-[#1E1D21] my-2 z-30">
            <div className="flex items-center justify-between w-full border-b border-gray-200 dark:border-[#2d2d33]">
                {tabs.map((tab) => (
                    <div
                        key={tab.name}
                        onClick={() => navigate(tab.path)}
                        className="relative flex flex-col items-center justify-center w-[20%] pt-2 pb-1 gap-0.5 cursor-pointer"
                    >
                        <tab.icon
                            className={`text-[18px] w-[18px] h-[18px] ${activeTab === tab.name
                                ? "text-[#3B9EFF]"
                                : "text-gray-900 dark:text-gray-100"
                                }`}
                        />
                        <span
                            className={`text-[9px] font-bold leading-none ${activeTab === tab.name
                                ? "text-[#3B9EFF]"
                                : "text-gray-900 dark:text-gray-100"
                                }`}
                        >
                            {tab.name}
                        </span>
                        {activeTab === tab.name && (
                            <motion.div
                                layoutId="account-tab-indicator"
                                className="absolute -bottom-[1.75px] h-[2px] w-8 rounded-full bg-[#3B9EFF] z-10"
                                transition={{ type: "spring", stiffness: 500, damping: 35 }}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
